import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { CountryOption, EmailRequest, RightOption } from 'src/app/LSR/participant/privacy-policy-form/privacy-policy-form.component';

@Injectable({
  providedIn: 'root'
})
export class PrivacypolicyformService {

  constructor(private http: HttpClient) { }

    GetRightOptionList(): Observable<RightOption[]> {
      return this.http.get<RightOption[]>(AppConfig.appsettings.apiRoot + '/GetRightOptionList')
      .pipe(catchError(this.handleError));
    }

    GetCountryList(): Observable<CountryOption[]> {
      return this.http.get<CountryOption[]>(AppConfig.appsettings.apiRoot + '/GetCountryList')
      .pipe(catchError(this.handleError));
    }

    Submit(emailRequest: EmailRequest): Observable<string> {    
      return this.http.post<string>(AppConfig.appsettings.apiRoot + '/Submit', emailRequest)
        .pipe(catchError(this.handleError));  
    }

    handleError(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
    }
}
